import { InformationCircleIcon } from "@heroicons/react/outline";
import Tooltip from "@mui/material/Tooltip";

type Props = {
  title: string;
  tooltip: any;
  className?: string;
  wrapperClassName?: string;
};

export const TitleWithTooltip = ({
  title,
  tooltip,
  className = "text-lg font-semibold",
  wrapperClassName = "flex items-center justify-center gap-2",
}: Props) => {
  return (
    <div className={wrapperClassName}>
      <h3 className={className}>{title}</h3>
      <Tooltip title={tooltip} arrow>
        <div className="w-5 h-5 text-gray-500 cursor-pointer">
          <InformationCircleIcon className="w-full h-full" />
        </div>
      </Tooltip>
    </div>
  );
};

export default TitleWithTooltip;
